var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_502_5603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 87C70.3675 87 88.5 68.8675 88.5 46.5C88.5 24.1325 70.3675 6 48 6C25.6325 6 7.50001 24.1325 7.50001 46.5C7.50001 68.8675 25.6325 87 48 87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 82.5C67.8823 82.5 84 66.3823 84 46.5C84 26.6178 67.8823 10.5 48 10.5C28.1178 10.5 12 26.6178 12 46.5C12 66.3823 28.1178 82.5 48 82.5Z",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4813 41.662C36.3788 41.662 37.917 39.154 37.917 36.0603C37.917 32.9666 36.3788 30.4587 34.4813 30.4587C32.5839 30.4587 31.0456 32.9666 31.0456 36.0603C31.0456 39.154 32.5839 41.662 34.4813 41.662Z",
    fill: "#505F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5187 41.662C63.4161 41.662 64.9543 39.154 64.9543 36.0603C64.9543 32.9666 63.4161 30.4587 61.5187 30.4587C59.6212 30.4587 58.083 32.9666 58.083 36.0603C58.083 39.154 59.6212 41.662 61.5187 41.662Z",
    fill: "#505F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6183 59.886C37.6183 59.886 47.2531 65.8611 57.3361 59.886",
    stroke: "#505F79",
    strokeWidth: 3.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_502_5603",
    x: -4.2,
    y: -3.9,
    width: 104.4,
    height: 104.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_5603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_5603",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.32784e39c3480ee220b4c700f720ffb9.svg";
export { ForwardRef as ReactComponent };